<template>
  <a
    class="m-the-header-logo"
    :disabled="!isLoading"
    href="#"
    @click.prevent="goToHome()"
  >
    <AtomLogoPrimary/>
  </a>
</template>

<script>
export default {
  name: 'MoleculeTheHeaderLogo',

  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    goToHome () {
      if (!this.isLoading) {
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>
